<template>
  <ul v-show="innerShow" class="custom-dropdown-menu" :style="{left:`${position.left}px`,top:`${position.top}px`}"
    @click.stop="onEventActions" v-click-outside="onClickOutside">
    <li v-if="options.allowSaveAs">
      <a href="javascript:;" data-action="saveAs">
        <span class="align-middle">{{$t('core.saveAs')}}</span>
      </a>
    </li>
    <li>
      <a href="javascript:;" data-action="import">
        <span class="align-middle">{{$t('core.import')}}</span>
      </a>
    </li>
    <li>
      <a href="javascript:;" data-action="domainSetting">
        <span class="align-middle">{{$t('core.preview_domain_configuration')}}</span>
      </a>
    </li>
    <li>
      <a href="javascript:;" data-action="staticSetting">
        <span class="align-middle">{{$t('cos.static_website_configuration')}}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import dropmenuBase from 'src/scripts/mixins/dropmenuBase';

export default {
  mixins: [dropmenuBase],
  props: {
    options: {
      type: Object,
      required: false,
      default: () => ({
        allowSaveAs: false,
      }),
    },
  },
};
</script>

<style scoped lang="scss">
</style>
